<template>
  <div class="resources-wrap">
    <top-label text="课程平移项目"/>
    <top-tab-and-search  @onChange="onSearchBtnClick">
      <span class="inline-block nav-item" style="width:160px" :class="{'router-link-active': subType==1}" @click="tabChange(1)">课程观察</span>
      <span class="inline-block nav-item" style="width:160px" :class="{'router-link-active': subType==2}" @click="tabChange(2)">跟进实验</span>
    </top-tab-and-search>
    <item-list :list='list' jumpurl="/research/result/detail"/>
    <div class="page-num w1200">
      <Page
        :total="total"
        @on-change="changePage"
        :page-size="pageSize"
        :current="pageNo"></Page>
    </div>
  </div>
</template>
<script>
import subjectTop from '../../components/subject/top-show';
import ItemList from './ItemList.vue';
import utils from "../../utils/index.js";

export default {
  name: 'index',
  components: {
    subjectTop,
    ItemList,
  },
  data(){
    return {
      //1 学校实践样态 2 课程平移项目 3 学术文献资料 4 项目学习案例
      type: 2,
      subType:1,
      list:[],
      total:1,
      pageSize:10,
      pageNo:1,
    }
  },
  mounted(){
    this.getList()
  },
  methods: {
    onSearchBtnClick(keyword){
      this.getList(1,this.pageSize,this.type,this.subType,keyword);
    },
    tabChange(subType){
      this.subType = subType;
      this.getList(1,this.pageSize,this.type,subType);
    },
    changePage(pageNo){
      this.getList(pageNo,this.pageSize,this.type,this.subType)
    },
    getList(pageNo=1,size=10,type=this.type,subType=1,keyword=""){
      utils.postAjax(utils.apis.Project_getListByPage,{
        pageNo,
        size,
        type,
        subType,
        name:keyword
      }).then(res=>{
        if(res.code==0){
          this.list = res.page&&res.page.list;
          this.total = res.page && res.page.totalCount;
          this.pageNo = pageNo
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .top-nav {
    height: 86px;
    background: rgba(244, 244, 244, 1);
    margin-bottom: 40px;
    .nav-item{
      width:122px;
      display: inline-block;
      height:50px;
      line-height: 50px;
      color: #555555;
      font-size: 20px;
      margin-top: 20px;
      text-align: center;
    }
    .nav-item.router-link-active{
      background:rgba(71,179,246,1);
      color: #ffffff;
    }
  }


</style>
